import { useState } from "react";
import TextShortener from "../TextShortener";

const MyUnitsReports = ({unit_name,username,dateofentry,monthofentry,yearofentry,message,men,women,youth,children,total_attend,tithe,
    offering,total,expensedetails,expenditure,remainingIncome,menAttend,youthAttend,womenAttend,childAttend,remarks}) => {

        const [showMendetails,setMendetails]=useState(false);
        const [showWomendetails,setWomendetails]=useState(false);
        const [showYouthdetails,setYouthdetails]=useState(false);
        const [showChildrendetails,setChildrendetails]=useState(false);
        const [showExpensesdetails,setExpdetails]=useState(false);

        const monthColors={
            "January": "#075E54",
            "December": "#0251EB",
            "February": "#ff4500",
            "March": "#FF3700B3",
            "April": "#6B014D",
            "May": "#1a1a1a",
            "June": "#29335c",
            "July": "#34B7F1",
            "August": "#25D366",
            "September": "#011F36",
            "October": "#696969",
            "November": "#000000"
        };



    return ( 
        <div className="myunitsreps flex-column1" key={dateofentry} style={{backgroundColor:monthColors[monthofentry]}}>
            <h2>{unit_name}</h2>
             <h2>{monthofentry},{yearofentry}</h2>
            <h3>submitted on: {dateofentry}</h3>
            <h4>submitted by: {username}</h4>
            <h4>Message Watched: {message}</h4> <br/>

            <h3 style={{borderBottom:"2px solid white"}}>Attendance</h3> 

            <div className="flex-row2" onClick={()=>setMendetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Men: {men}</h4>
            <svg            
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showMendetails && 
                <div className="detaillist">
                    <pre>{menAttend}</pre>
                </div>           
            }
            </div>
            
            <div className="flex-row2" onClick={()=>setWomendetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Women: {women}</h4>
            <svg
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showWomendetails && 
                <div className="detaillist">
                    <pre>{womenAttend}</pre>
                </div>           
            }
            </div>

            <div className="flex-row2" onClick={()=>setYouthdetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Youth: {youth}</h4>
            <svg
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showYouthdetails && 
                <div className="detaillist">
                    <pre>{youthAttend}</pre>
                </div>           
            }
            </div>
           
            <div className="flex-row2" onClick={()=>setChildrendetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Children: {children}</h4>
            <svg          
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showChildrendetails && 
                <div className="detaillist">
                    <pre>{childAttend}</pre>
                </div>           
            }
            </div>
            
            <h4>Total Attendees: {total_attend}</h4> <br/>

            <h3 style={{borderBottom:"2px solid white"}}>Finance</h3>
            <h4>Tithe: {parseFloat(tithe).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}</h4>
            <h4>Offering: {parseFloat(offering).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}</h4>
            <h4>Total Income: {parseFloat(total).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h4>

            <div className="flex-row2" onClick={()=>setExpdetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
                    <h4>Expenses: {expenditure ? parseFloat(expenditure).toLocaleString('en-US',{
                        style:'currency',currency: 'GHS'
                    }) : "GHS 0" }
                    </h4>

                    <svg                  
                    cursor="pointer"
                    viewBox="0 0 24 24"
                    fill="white"
                    height="1.5em"
                    width="1.5em">
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>

                    {showExpensesdetails && 
                        <div className="detaillist">
                            <pre>{expensedetails && expensedetails}</pre>
                        </div>           
                    }
            </div>
          
            <h4>Net Income: {remainingIncome && parseFloat(remainingIncome).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h4>
            <br/>

            <h4>Remarks</h4>
            <div className="remarkdiv">
            {remarks && <TextShortener fullText={remarks} words={12}/>}
            </div> 
            <br/>
        </div>
     );
}
export default MyUnitsReports;